module.exports = __webpack_public_path__ + "img/lemigas_logo.db348c82.png";